import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import { lightboxStyles } from './css/styles';

export const Lightbox = injectSheet(lightboxStyles)(({
  buttonOkText,
  icon,
  isOpen,
  children,
  classes,
  onCancel,
  onSubmit,
  title,
  showClose,
}) => (
  <ReactModal
    isOpen={isOpen}
    overlayClassName={classes.overlay}
    className={classes.container}
    onRequestClose={onCancel}
  >
    <div className={classNames('lightbox', classes.lightbox)}>
      <div className={classNames('lightbox-header', classes.header)}>
        {showClose && (
          <div className="float-right close">
            <button className="lightbox-button-close close" onClick={onCancel}>
              <span className="glyphicon glyphicon-remove" />
            </button>
          </div>
        )}
        <span className={classNames('lightbox-title', 'type-bold', 'center-block', classes.title)}>
          {icon}
          {title}
        </span>
      </div>
      <div className={classNames('lightbox-body', classes.body)}>
        {children}
      </div>
      <div className={classNames('lightbox-footer', classes.footer)}>
        <button className={classNames('lightbox-button-ok', classes.buttonOk)} onClick={onSubmit}>{buttonOkText}</button>
      </div>
    </div>
  </ReactModal>
));

Lightbox.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  buttonOkText: PropTypes.string.isRequired,
  showClose: PropTypes.bool,
};

Lightbox.defaultProps = {
  icon: null,
  showClose: true,
};

Lightbox.displayName = 'Lightbox';
